import React from 'react';
import {
  View, StatusBar, SafeAreaView, StyleSheet, Text,
} from 'react-native';
import { Video } from 'expo-av';
import HeaderBackButton from '../components/HeaderBackButton';
import APMStyles from '../styles';

function VideoPlayer({ navigation, route }) {
  // const videoRef = useRef(null);
  // const [videoNumber, setVideoNumber] = useState(0);
  // const [shouldPlay, setShouldPlay] = useState(true);
  const { video } = route.params;

  // const onPlaybackStatusUpdate = (playbackStatus) => {
  //   if (playbackStatus.didJustFinish) {
  //     const newVideoNumber = (videoNumber + 1) % videos.length;
  //     if (videoNumber !== newVideoNumber) {
  //       setVideoNumber(newVideoNumber);
  //     }
  //   }
  // };

  // useFocusEffect(
  //   useCallback(() => {
  //     // screen focused
  //     setShouldPlay(true);
  //     videoRef.current.playAsync();
  //     return () => {
  //       // screen unfocused
  //       videoRef.current.stopAsync();
  //       videoRef.current.unloadAsync();
  //       setShouldPlay(false);
  //       setVideoNumber(0);
  //     };
  //   }, []),
  // );

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" />
      <HeaderBackButton style={styles.header} navigation={navigation} />

      <View style={styles.titleContainer}>
        <Text style={styles.title}>{video.name.toUpperCase()}</Text>
      </View>

      <View style={styles.videoContainer}>
        <Video
          style={{ flex: 1 }}
          source={{
            uri: video.video,
          }}
          useNativeControls
          resizeMode="contain"
        />
      </View>

      <View style={styles.controlsContainer} />

    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: APMStyles.colors.background,
  },
  header: {
    flex: 2,
  },
  titleContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    letterSpacing: 6,
    fontSize: APMStyles.typography.title,
  },
  videoContainer: {
    flex: 19,
  },
  video: {
    alignSelf: 'center',
  },
  controlsContainer: {
    flex: 2,
  },
});

export default VideoPlayer;
